import { useEffect, useMemo, useState } from 'react';
import { useQueryParams } from '@/hooks';
import { DriversFilter } from '../models';

const useDriversFilter = () => {
  const { getQueryParam, setQueryParams } = useQueryParams();

  const initialFilter: DriversFilter = useMemo(
    () => ({
      search: '',
      email: undefined,
      phone: undefined,
      status: undefined,
      currentOperatorId: undefined,
    }),
    []
  );

  const [filter, setFilter] = useState<DriversFilter>(() => ({
    search: getQueryParam('search') || '',
    email: getQueryParam('email') || undefined,
    phone: getQueryParam('phone') || undefined,
    status: getQueryParam('status') || undefined,
    currentOperatorId: getQueryParam('currentOperatorId') || undefined,
  }));

  useEffect(() => {
    setQueryParams({
      search: filter.search || undefined,
      email: filter.email || undefined,
      phone: filter.phone || undefined,
      status: filter.status || undefined,
      currentOperatorId: filter.currentOperatorId || undefined,
    });
  }, [filter]);

  return { filter, initialFilter, setFilter };
};

export default useDriversFilter;
